import axios from "axios";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Button from "components/button";
import AuthLayout from "components/AuthLayout";
import UseContext from "hooks/useContext";
import { toast } from "react-toastify";
import AddressInfos from "./Forms/addressInfos";
import NameInfos from "./Forms/nameInfos";
import PreferenceQualification from "./Forms/preferenceQualification";
import Register from "./Forms/Register";
import TokenRegister from "./Forms/tokenRegister";

const FormRegister = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setEmail } = UseContext();
  const [page, setPage] = useState(0);

  const queryParams = new URLSearchParams(location.search);
  const inviteToken = queryParams.get('invite');

  const [inviteData, setInviteData] = useState(null);

  useEffect(() => {
    if (inviteToken) {
      axios.get(`${process.env.REACT_APP_API_URL}invitation/verify/${inviteToken}`)
        .then(res => {
          setInviteData(res.data);
          setUserData(prev => ({
            ...prev,
            email: res.data.email || prev.email,
            nom: res.data.lastname?.toUpperCase() || prev.nom,
            prenom: res.data.firstname ? res.data.firstname.replace(/\b\w/g, l => l.toUpperCase()) : prev.prenom,
          }));
        })
        .catch(() => {});
    }
  }, [inviteToken]);

  const [userData, setUserData] = useState({
    email: "",
    password: "",
    confirmPassword: "",
    nom: "",
    prenom: "",
    phone: "",
    birthday: "",
    address: {},
    preferenceQualifications: [],
  });
  const [validFormRegister, setValidFormRegister] = useState(false);
  const [validFormName, setValidFormName] = useState(false);
  const [validFormAddress, setValidFormAddress] = useState(false);
  const [
    validFormPreferenceQualification,
    setValidFormPreferenceQualification,
  ] = useState(false);
  const formTitles = [
    "S’inscrire sur Jobbiz",
    "Quel est votre nom ?",
    "Où vous situez-vous ?",
    "Quels postes recherchez-vous ?",
    "Vérification par mail",
    "Compte créé avec succès !",
  ];
  const formDescriptions = [
    "En m'inscrivant, j'accepte les conditions et la politique de confidentialité de Jobbiz.",
    "Vos nom et prénom seront utilisés sur votre profil et vos documents (contrats, fiches de paie).",
    "Ces informations nous permettent de vous proposer des missions adaptées à votre zone géographique.",
    null,
    "Nous vous avons envoyé un mot de passe unique à votre e-mail, tapez votre code ici.",
    null,
  ];

  const PageDisplay = () => {
    if (page === 0) {
      return (
        <Register
          userData={userData}
          setUserData={setUserData}
          setValidFormRegister={setValidFormRegister}
          lockedEmail={!!inviteData?.email}
        />
      );
    } else if (page === 1) {
      return (
        <NameInfos
          userData={userData}
          setUserData={setUserData}
          setValidFormName={setValidFormName}
          lockedFirstname={!!inviteData?.firstname}
          lockedLastname={!!inviteData?.lastname}
        />
      );
    } else if (page === 2) {
      return (
        <AddressInfos
          userData={userData}
          setUserData={setUserData}
          setValidFormAddress={setValidFormAddress}
        />
      );
    } else if (page === 3) {
      return (
        <PreferenceQualification
          userData={userData}
          setUserData={setUserData}
          setValidFormPreferenceQualification={
            setValidFormPreferenceQualification
          }
        />
      );
    } else if (page === 4) {
      return <TokenRegister userData={userData} onValidated={() => setPage(5)} />;
    } else if (page === 5) {
      return (
        <div className="flex flex-col items-start gap-6 py-4 w-full">
          <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center shrink-0">
            <span className="text-3xl">🎉</span>
          </div>
          <p className="text-gray-700 text-left w-full">
            Vous allez recevoir un message pour finaliser votre inscription sur Jobbiz. Pensez à vérifier vos spams.
          </p>
          <button
            type="button"
            onClick={() => navigate('/login/interimaire')}
            className="w-full h-14 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors font-semibold text-base"
          >
            Se connecter
          </button>
        </div>
      );
    }
  };

  const handleNextForm = (e) => {
    e.preventDefault();
    if (validFormRegister) {
      if (page !== formTitles.length - 1) {
        let isStepValid = false;

        if (page === 0) {
          //check if password have this conditions : 1 uppercase, 1 lowercase, 1 number, 1 special character and 8 characters minimum and 40 maximum
          if (
            validFormRegister &&
            userData.password === userData.confirmPassword &&
            userData.password.match(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*\W)[a-zA-Z0-9\S]{8,40}$/
            ) &&
            userData.email.match(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/)
          ) {
            isStepValid = true;
          }
        } else if (page === 1) {
          if (validFormName) {
            isStepValid = true;
          }
        } else if (page === 2) {
          if (validFormAddress) {
            isStepValid = true;
          }
        }

        if (isStepValid) setPage((currPage) => currPage + 1);
      }
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validFormRegister && validFormName) {
      setEmail(userData.email);
      userData.birthday = userData.birthday.split("-").reverse().join("-");

      let ip = null;
      let browser = null;
      let os = null;
      let device = null;
      let country = null;
      let city = null;
      let region = null;
      let latitude = null;
      let longitude = null;
      let timezone = null;
      //get ip address and other info with https://ipinfo.io/json
      const ipInfos = await axios
        .get(
          `https://ipinfo.io/json?token=${process.env.REACT_APP_IPINFO_TOKEN}`
        )
        .then((res) => res.data)
        .catch((err) => null);

      if (ipInfos) {
        ip = ipInfos.ip;
        country = ipInfos.country;
        city = ipInfos.city;
        region = ipInfos.region;
        latitude = ipInfos.loc.split(",")[0];
        longitude = ipInfos.loc.split(",")[1];
        timezone = ipInfos.timezone;
      }

      //get browser, os, device
      let OSName = "Unknown OS";
      if (navigator.appVersion.indexOf("Win") !== -1) OSName = "Windows";
      if (navigator.appVersion.indexOf("Mac") !== -1) OSName = "MacOS";
      if (navigator.appVersion.indexOf("X11") !== -1) OSName = "UNIX";
      if (navigator.appVersion.indexOf("Linux") !== -1) OSName = "Linux";
      if (navigator.appVersion.indexOf("Android") !== -1) OSName = "Android";
      if (navigator.appVersion.indexOf("like Mac") !== -1) OSName = "iOS";

      os = OSName;

      let userAgent = navigator?.userAgent;

      if (userAgent) {
        //return browser name and version
        if (userAgent.indexOf("Chrome") !== -1) browser = "Chrome";
        else if (userAgent.indexOf("Safari") !== -1) browser = "Safari";
        else if (userAgent.indexOf("Firefox") !== -1) browser = "Firefox";
        else if (userAgent.indexOf("MSIE") !== -1) browser = "IE";
        else browser = "Unknown Browser";

        //return device name and type
        if (userAgent.indexOf("Mobile") !== -1) device = "Mobile";
        else if (userAgent.indexOf("Tablet") !== -1) device = "Tablet";
        else device = "Desktop";
      }

      axios({
        method: "post",
        url: `${process.env.REACT_APP_API_URL}user/register`,
        data: {
          firstname: userData.prenom,
          lastname: userData.nom,
          email: userData.email,
          password: userData.password,
          birthday: userData.birthday,
          phone: userData.phone,
          address: userData.address,
          preferenceQualifications: userData.preferenceQualifications,
          ip,
          browser,
          os,
          device,
          country,
          city,
          region,
          latitude,
          longitude,
          timezone,
          ...(inviteToken ? { inviteToken } : {}),
        },
      }).then((res) => {
        if (res.data.errors) {
          toast.error(res.data.errors);
        } else {
          setPage((currPage) => currPage + 1);
        }
      });
    } else {
      toast.error("Le formulaire n'est pas valide");
    }
  };
  const handleReturn = (e) => {
    setPage((currPage) => currPage - 1);
  };
  const handleNavigate = (e) => {
    navigate("/login/interimaire");
  };
  const mobileBottomBar = (
    <>
      {page === 0 && (
        <div className="tab:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-8 py-4 z-50 w-full min-w-0">
          <div className="w-full max-w-none tab:max-w-[560px] tab:mx-auto mx-0 flex flex-col gap-1.5">
            {validFormRegister ? (
              <Button size={"FULL"} onClick={(e) => handleNextForm(e)}>S'inscrire</Button>
            ) : (
              <Button size={"FULL"} color={"DISABLED"}>S'inscrire</Button>
            )}
            <button
              type="button"
              onClick={handleNavigate}
              className="w-full py-2.5 text-center ft-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 active:bg-gray-100 rounded-lg transition-colors"
            >
              Je suis déjà inscrit
            </button>
          </div>
        </div>
      )}
      {page > 0 && page < 4 && (
        <div className="tab:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-100 px-8 py-4 z-50 w-full min-w-0">
          <div className="w-full max-w-none tab:max-w-[560px] tab:mx-auto mx-0 flex flex-col gap-3">
            <div className="flex gap-2 w-full">
              <div className={`h-1 rounded-lg w-full ${page >= 1 ? "bg-yellow-500" : "bg-yellow-300"}`}></div>
              <div className={`h-1 rounded-lg w-full ${page >= 2 ? "bg-yellow-500" : "bg-yellow-300"}`}></div>
              <div className={`h-1 rounded-lg w-full ${page >= 3 ? "bg-yellow-500" : "bg-yellow-300"}`}></div>
            </div>
            <div className="flex gap-3 w-full min-w-0">
              <Button size={"LG"} color={"SECONDARY"} onClick={() => handleReturn()}>Retour</Button>
              {page === 3 ? (
                <Button size={"FULL"} color={validFormPreferenceQualification ? undefined : "DISABLED"} onClick={(e) => validFormPreferenceQualification && handleSubmit(e)}>
                  Confirmer ({userData.preferenceQualifications.length}/5)
                </Button>
              ) : (
                <Button size={"FULL"} color={(page === 1 && validFormName) || (page === 2 && validFormAddress) ? undefined : "DISABLED"} onClick={(e) => handleNextForm(e)}>
                  Suivant
                </Button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );

  return (
    <AuthLayout
      bottomBar={mobileBottomBar}
      contentClassName={page < 4 ? 'pb-28 tab:pb-12' : ''}
    >
      <div className="text-left flex flex-col gap-2 tab:gap-3 w-full">
        <h1 className="text-2xl tab:text-3xl font-medium text-[#111827]">
          {formTitles[page]}
        </h1>
        {formDescriptions[page] && (
          <p className="text-gray-500 text-sm tab:text-base tab:leading-relaxed">
            {formDescriptions[page]}
          </p>
        )}
      </div>
      <form className="space-y-6 tab:space-y-8 w-full min-w-0">
        {PageDisplay()}

        {page > 0 && page < 4 && (
          <div className="hidden tab:flex gap-3 w-full max-w-xl mx-auto pt-1 tab:pt-2">
            <div className={`h-1 rounded-lg w-full ${page >= 1 ? "bg-yellow-500" : "bg-yellow-300"}`}></div>
            <div className={`h-1 rounded-lg w-full ${page >= 2 ? "bg-yellow-500" : "bg-yellow-300"}`}></div>
            <div className={`h-1 rounded-lg w-full ${page >= 3 ? "bg-yellow-500" : "bg-yellow-300"}`}></div>
          </div>
        )}
        {page > 0 && page < 4 && (
          <div className="hidden tab:flex gap-4 w-full min-w-0 max-w-xl mx-auto justify-center">
            <Button size={"LG"} color={"SECONDARY"} onClick={() => handleReturn()}>Retour</Button>
            {page === 3 ? (
              <Button size={"FULL"} color={validFormPreferenceQualification ? undefined : "DISABLED"} onClick={(e) => validFormPreferenceQualification && handleSubmit(e)}>
                Confirmer ({userData.preferenceQualifications.length}/5)
              </Button>
            ) : (
              <Button size={"FULL"} color={(page === 1 && validFormName) || (page === 2 && validFormAddress) ? undefined : "DISABLED"} onClick={(e) => handleNextForm(e)}>
                Suivant
              </Button>
            )}
          </div>
        )}

        {page === 0 && (
          <div className="hidden tab:flex tab:flex-col tab:items-center tab:gap-4">
            <div className="w-full max-w-xl">
              {validFormRegister ? (
                <Button size={"FULL"} onClick={(e) => handleNextForm(e)}>S'inscrire</Button>
              ) : (
                <Button size={"FULL"} color={"DISABLED"}>S'inscrire</Button>
              )}
            </div>
            <div className="w-full max-w-xl">
              <button
                type="button"
                onClick={handleNavigate}
                className="w-full py-2.5 text-center ft-sm font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 active:bg-gray-100 rounded-lg transition-colors"
              >
                Je suis déjà inscrit
              </button>
            </div>
          </div>
        )}
      </form>
    </AuthLayout>
  );
};

export default FormRegister;
